import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 4.75C6 4.05964 6.55964 3.5 7.25 3.5H12.25C14.8734 3.5 17 5.62665 17 8.25C17 9.26565 16.6812 10.2068 16.1383 10.979C17.83 11.7805 19 13.5036 19 15.5C19 18.2614 16.7614 20.5 14 20.5H7.25C6.55964 20.5 6 19.9404 6 19.25V4.75ZM8.5 13V18H14C15.3807 18 16.5 16.8807 16.5 15.5C16.5 14.1193 15.3807 13 14 13H8.5ZM8.5 10.5L12.2513 10.5C13.4933 10.4993 14.5 9.49222 14.5 8.25C14.5 7.00736 13.4926 6 12.25 6H8.5V10.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgBold;
